<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
        :disable-full-screen="true"
        :width="width"
    >
      <template v-slot:body="{height}">
        <v-sheet class="py-7 px-5" v-if="!!storeAggregate && !!storeAggregate.rootData && storeDetail.uidItem"
                 :width="width">
          <v-row>
            <v-col cols="6" class="px-5">
              <v-row>
                <CommonFieldString
                    dense
                    v-model="currentItem.designator"
                    outlined
                    :label="$t('article')"
                >
                </CommonFieldString>
              </v-row>
              <v-row>
                <CommonFieldString
                    dense
                    v-model="currentItem.layer"
                    outlined
                    :label="$t('layer')"
                >
                </CommonFieldString>
              </v-row>
              <v-row>
                <CommonFieldNumber
                    dense
                    v-model="currentItem.center_x"
                    outlined
                    :label="$t('center_x')"
                >
                </CommonFieldNumber>
              </v-row>
              <v-row>
                <CommonFieldNumber
                    dense
                    v-model="currentItem.center_y"
                    outlined
                    :label="$t('center_y')"
                >
                </CommonFieldNumber>
              </v-row>
              <v-row>
                <CommonFieldNumber
                    dense
                    v-model="currentItem.rotation"
                    outlined
                    :label="$t('rotation')"
                >
                </CommonFieldNumber>
              </v-row>
              <v-row>
                <CommonFieldNumber
                    dense
                    v-model="currentItem.customer_article"
                    outlined
                    :label="$t('customer_article')"
                >
                </CommonFieldNumber>
              </v-row>
            </v-col>
            <v-col cols="6" class="px-5">
              <v-row>
                <CommonFieldText
                    dense
                    v-model="currentItem.original_description"
                    :label="$t('original_description')"
                    rows="6"
                    class="mb-5"
                >
                </CommonFieldText>
              </v-row>
              <v-row>
                <CommonFieldText
                    dense
                    v-model="currentItem.comment"
                    :label="$t('comment')"
                    rows="6"
                    class="mb-5"
                >
                </CommonFieldText>
              </v-row>
            </v-col>
          </v-row>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber";
import CommonFieldText from "@/components/Common/CommonFieldText";
import ComponentTable from "@/components/CoreComponent/Component/ComponentTable";
import {v4 as uuidv4} from "uuid";
import {useTableStore} from "@/components/Common/CommonTable";

export default {
  name: "CorePickPlaceSheetDetail",

  props: {
    uidItem: {default: null},
    width: {default: '1200'},
    storeName: {type: [String], default: 'CorePickPlaceSheetDetail'},
    dtoDetailQuery: {default: 'PickPlaceSheetDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'PickPlaceSheetActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'PickPlaceSheetSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'PickPlaceSheetValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'PickPlaceSheetDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CorePickPlaceSheetTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonDetail,
    CommonFieldString,
    CommonFieldNumber,
    CommonFieldText,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
  },

  methods: {}
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>